import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Paper, Box, Typography, TextField, FormControlLabel,
} from '@material-ui/core';
import '../TargetSearchComponent';
import { LATEST_FLG, TARGET_SEARCH_DISP_ITEM } from '../../../../common/const';
import {
  setAccountMonth,
  setSalesFrom,
  setSalesTo,
  setSalesRateFrom,
  setSalesRateTo,
  setBenefitFrom,
  setBenefitTo,
  setBenefitRateFrom,
  setBenefitRateTo,
  setDispSalesFrom,
  setDispSalesTo,
  setDispSalesRateFrom,
  setDispSalesRateTo,
  setDispBenefitFrom,
  setDispBenefitTo,
  setDispBenefitRateFrom,
  setDispBenefitRateTo,
  setErrMsgSales,
  setErrMsgRate,
  setErrMsgBenefit,
  setErrMsgBenefitRate,
  setCheckSalesFrom,
  setCheckSalesTo,
  setCheckRateFrom,
  setCheckRateTo,
  setCheckBenefitFrom,
  setCheckBenefitTo,
  setCheckBenefitRateFrom,
  setCheckBenefitRateTo,
  setLatestFlg,
} from '../../../actions/TargetAction';
import styles from '../style.module.css';
import validator, { VALIDATOR_CONST } from '../../../../common/validator';
import { ERROR } from '../../../../common/message';
import { getMessage } from '../../../../common/util';
import CustomCheckbox from '../../common/CustomCheckbox';

class SettlementInfomation extends Component {
  /**
  *事業所数FROM文字種、最大桁数のチェック
  *事業所数TO文字種、最大桁数のチェック
  */
  onBlurOfficeCount = () => {
    const {
      dispOfficeCountFrom,
      dispOfficeCountTo,
      setOfficeCountFromAct,
      setOfficeCountToAct,
      setCheckOfficeCountFromAct,
      setCheckOfficeCountToAct,
      setErrMsgOfficeCountAct,
      setDispOfficeCountFromAct,
      setDispOfficeCountToAct,
    } = this.props;

    // カンマ除去
    const officeCountFrom = dispOfficeCountFrom && dispOfficeCountFrom.replace(/,/g, '');
    const officeCountTo = dispOfficeCountTo && dispOfficeCountTo.replace(/,/g, '');

    // リクエストパラメータ用項目設定
    setOfficeCountFromAct(officeCountFrom);
    setOfficeCountToAct(officeCountTo);

    // 入力チェック
    const msgs1 = [];
    const msgs2 = [];
    validator.checkChar(officeCountFrom, VALIDATOR_CONST.PATERN_POSITIVE, msgs1);
    validator.checkChar(officeCountTo, VALIDATOR_CONST.PATERN_POSITIVE, msgs2);
    validator.checkNumberRange(officeCountFrom, 1, 99999, msgs1);
    validator.checkNumberRange(officeCountTo, 1, 99999, msgs2);
    const errFlg1 = msgs1.length !== 0;
    const errFlg2 = msgs2.length !== 0;

    if (errFlg1 || errFlg2) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      const msgs = [...new Set(msgs1.concat(msgs2))];
      setErrMsgOfficeCountAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckOfficeCountFromAct(errFlg1);
      setCheckOfficeCountToAct(errFlg2);
      return;
    }
    setErrMsgOfficeCountAct();
    setCheckOfficeCountFromAct(false);
    setCheckOfficeCountToAct(false);

    // 表示内容を更新(3桁カンマを付与)
    setDispOfficeCountFromAct(officeCountFrom ? Number(officeCountFrom).toLocaleString() : '');
    setDispOfficeCountToAct(officeCountTo ? Number(officeCountTo).toLocaleString() : '');
  }

  onBlurSales = () => {
    const {
      dispSalesFrom,
      dispSalesTo,
      setSalesFromAct,
      setSalesToAct,
      setCheckSalesFromAct,
      setCheckSalesToAct,
      setErrMsgSalesAct,
      setDispSalesFromAct,
      setDispSalesToAct,
    } = this.props;

    // カンマ除去
    const salesFrom = dispSalesFrom && dispSalesFrom.replace(/,/g, '');
    const salesTo = dispSalesTo && dispSalesTo.replace(/,/g, '');

    // リクエストパラメータ用項目設定
    setSalesFromAct(salesFrom);
    setSalesToAct(salesTo);

    // 入力チェック
    const msgs1 = [];
    const msgs2 = [];
    validator.checkChar(salesFrom, VALIDATOR_CONST.PATERN_SIGNED, msgs1);
    validator.checkChar(salesTo, VALIDATOR_CONST.PATERN_SIGNED, msgs2);
    validator.checkMaxLength(salesFrom, 16, msgs1);
    validator.checkMaxLength(salesTo, 16, msgs2);

    const errFlg1 = msgs1.length !== 0;
    const errFlg2 = msgs2.length !== 0;

    if (errFlg1 || errFlg2) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      const msgs = [...new Set(msgs1.concat(msgs2))];
      setErrMsgSalesAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckSalesFromAct(errFlg1);
      setCheckSalesToAct(errFlg2);
      return;
    }

    // エラー無しの場合
    // エラーメッセージ、エラーフラグを解除
    setErrMsgSalesAct();
    setCheckSalesFromAct(false);
    setCheckSalesToAct(false);
    // 表示内容を更新(3桁カンマを付与)
    setDispSalesFromAct(salesFrom ? salesFrom.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '');
    setDispSalesToAct(salesTo ? salesTo.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '');
  }

  onBlurRate = () => {
    const {
      dispSalesRateFrom,
      dispSalesRateTo,
      setSalesRateFromAct,
      setSalesRateToAct,
      setCheckRateFromAct,
      setCheckRateToAct,
      setErrMsgRateAct,
      setDispSalesRateFromAct,
      setDispSalesRateToAct,
    } = this.props;

    // カンマ除去
    const salesRateFrom = dispSalesRateFrom && dispSalesRateFrom.replace(/,/g, '');
    const salesRateTo = dispSalesRateTo && dispSalesRateTo.replace(/,/g, '');

    // リクエストパラメータ用項目設定
    setSalesRateFromAct(salesRateFrom);
    setSalesRateToAct(salesRateTo);

    // 入力チェック
    const msgs1 = [];
    const msgs2 = [];
    validator.checkChar(salesRateFrom, VALIDATOR_CONST.PATERN_DECIMAL, msgs1);
    validator.checkChar(salesRateTo, VALIDATOR_CONST.PATERN_DECIMAL, msgs2);
    validator.checkMaxLength(salesRateFrom, 11, msgs1);
    validator.checkMaxLength(salesRateTo, 11, msgs2);

    const errFlg1 = msgs1.length !== 0;
    const errFlg2 = msgs2.length !== 0;

    if (errFlg1 || errFlg2) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      const msgs = [...new Set(msgs1.concat(msgs2))];
      setErrMsgRateAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckRateFromAct(errFlg1);
      setCheckRateToAct(errFlg2);
      return;
    }

    // エラー無しの場合
    // エラーメッセージ、エラーフラグを解除
    setErrMsgRateAct();
    setCheckRateFromAct(false);
    setCheckRateToAct(false);
    // 表示内容を更新(3桁カンマを付与)
    setDispSalesRateFromAct(salesRateFrom ? Number(salesRateFrom).toLocaleString() : '');
    setDispSalesRateToAct(salesRateTo ? Number(salesRateTo).toLocaleString() : '');
  }

  /**
    *利益金FROM文字種、最大桁数のチェック
    *利益金TO文字種、最大桁数のチェック
    */
  onBlurBenefit = () => {
    const {
      dispBenefitFrom,
      dispBenefitTo,
      setBenefitFromAct,
      setBenefitToAct,
      setCheckBenefitFromAct,
      setCheckBenefitToAct,
      setErrMsgBenefitAct,
      setDispBenefitFromAct,
      setDispBenefitToAct,
    } = this.props;

    // カンマ除去
    const benefitFrom = dispBenefitFrom && dispBenefitFrom.replace(/,/g, '');
    const benefitTo = dispBenefitTo && dispBenefitTo.replace(/,/g, '');

    // リクエストパラメータ用項目設定
    setBenefitFromAct(benefitFrom);
    setBenefitToAct(benefitTo);

    // 入力チェック
    const msgs1 = [];
    const msgs2 = [];
    validator.checkChar(benefitFrom, VALIDATOR_CONST.PATERN_SIGNED, msgs1);
    validator.checkChar(benefitTo, VALIDATOR_CONST.PATERN_SIGNED, msgs2);
    validator.checkMaxLength(benefitFrom, 13, msgs1);
    validator.checkMaxLength(benefitTo, 13, msgs2);

    const errFlg1 = msgs1.length !== 0;
    const errFlg2 = msgs2.length !== 0;

    if (errFlg1 || errFlg2) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      const msgs = [...new Set(msgs1.concat(msgs2))];
      setErrMsgBenefitAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckBenefitFromAct(errFlg1);
      setCheckBenefitToAct(errFlg2);
      return;
    }

    // エラー無しの場合
    // エラーメッセージ、エラーフラグを解除
    setErrMsgBenefitAct();
    setCheckBenefitFromAct(false);
    setCheckBenefitToAct(false);
    // 表示内容を更新(3桁カンマを付与)
    setDispBenefitFromAct(benefitFrom ? Number(benefitFrom).toLocaleString() : '');
    setDispBenefitToAct(benefitTo ? Number(benefitTo).toLocaleString() : '');
  }

  /**
    *利益伸び率FROM文字種、最大桁数のチェック
    *利益伸び率TO文字種、最大桁数のチェック
    */
  onBlurBenefitRate = () => {
    const {
      dispBenefitRateFrom,
      dispBenefitRateTo,
      setBenefitRateFromAct,
      setBenefitRateToAct,
      setCheckBenefitRateFromAct,
      setCheckBenefitRateToAct,
      setErrMsgBenefitRateAct,
      setDispBenefitRateFromAct,
      setDispBenefitRateToAct,
    } = this.props;

    // カンマ除去
    const benefitRateFrom = dispBenefitRateFrom && dispBenefitRateFrom.replace(/,/g, '');
    const benefitRateTo = dispBenefitRateTo && dispBenefitRateTo.replace(/,/g, '');

    // リクエストパラメータ用項目設定
    setBenefitRateFromAct(benefitRateFrom);
    setBenefitRateToAct(benefitRateTo);

    // 入力チェック
    const msgs1 = [];
    const msgs2 = [];
    validator.checkChar(benefitRateFrom, VALIDATOR_CONST.PATERN_DECIMAL, msgs1);
    validator.checkChar(benefitRateTo, VALIDATOR_CONST.PATERN_DECIMAL, msgs2);
    validator.checkMaxLength(benefitRateFrom, 11, msgs1);
    validator.checkMaxLength(benefitRateTo, 11, msgs2);

    const errFlg1 = msgs1.length !== 0;
    const errFlg2 = msgs2.length !== 0;

    if (errFlg1 || errFlg2) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      const msgs = [...new Set(msgs1.concat(msgs2))];
      setErrMsgBenefitRateAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckBenefitRateFromAct(errFlg1);
      setCheckBenefitRateToAct(errFlg2);
      return;
    }

    // エラー無しの場合
    // エラーメッセージ、エラーフラグを解除
    setErrMsgBenefitRateAct();
    setCheckBenefitRateFromAct(false);
    setCheckBenefitRateToAct(false);
    // 表示内容を更新(3桁カンマを付与)
    setDispBenefitRateFromAct(benefitRateFrom ? Number(benefitRateFrom).toLocaleString() : '');
    setDispBenefitRateToAct(benefitRateTo ? Number(benefitRateTo).toLocaleString() : '');
  }

  checkLatestFlg = () => {
    const {
      setLatestFlgAct,
      latestFlg,
    } = this.props;
    if (latestFlg === LATEST_FLG.LATEST_OFF) {
      setLatestFlgAct(LATEST_FLG.LATEST_ON);
    } else {
      setLatestFlgAct(LATEST_FLG.LATEST_OFF);
    }
  }

  /**
 *決算月チェックボックス変更
 */
  onChangeAccountMonthCheckBox = (num) => {
    const { setAccountMonthAct, accountMonth } = this.props;
    // 選択した決算月を取得
    const selMonth = num;
    // 決算月リスト編集用の変数を宣言
    let newAccountMonth = [];

    if (accountMonth.indexOf(num) === -1) {
      // 選択した決算月を決算月リストに追加
      newAccountMonth.push(selMonth);
      // 他に選択済の決算月がある場合は決算月リストに追加
      if (accountMonth && accountMonth.length > 0) {
        newAccountMonth = accountMonth.concat(newAccountMonth);
      }
    } else {
      // チェックOFFに変更した決算月の配列位置を取得
      const delIndex = accountMonth.indexOf(selMonth);
      // 配列位置が取得できた場合、該当の決算月を削除
      if (delIndex >= 0) {
        newAccountMonth = accountMonth.concat(newAccountMonth);
        newAccountMonth.splice(delIndex, 1);
      }
    }
    setAccountMonthAct(newAccountMonth);
  };

  render() {
    const {
      checkErrFlg,
      dispSalesFrom,
      dispSalesTo,
      dispSalesRateFrom,
      dispSalesRateTo,
      dispBenefitFrom,
      dispBenefitTo,
      setDispSalesFromAct,
      setDispSalesToAct,
      setDispSalesRateFromAct,
      setDispSalesRateToAct,
      setDispBenefitFromAct,
      setDispBenefitToAct,
      setDispBenefitRateFromAct,
      setDispBenefitRateToAct,
      dispBenefitRateFrom,
      dispBenefitRateTo,
      errMsgSales,
      errMsgRate,
      errMsgBenefit,
      errMsgBenefitRate,
      accountMonth,
      latestFlg,
      targetingDispItems,
    } = this.props;

    // 最新決算月の表示内容を設定
    const monthlist = [];
    for (let num = 1; num <= 6; num += 1) {
      monthlist.push(
        <FormControlLabel
          key={num}
          control={
            (
              <CustomCheckbox
                onChange={() => this.onChangeAccountMonthCheckBox(num)}
                checked={accountMonth.indexOf(num) > -1}
              />
            )
          }
          label={`${num}月`}
          className={`${styles.accountMonthItem}`}
        />,
      );
    }
    const monthlist2 = [];
    for (let num = 7; num <= 12; num += 1) {
      monthlist2.push(
        <FormControlLabel
          key={num}
          control={
            (
              <CustomCheckbox
                onChange={() => this.onChangeAccountMonthCheckBox(num)}
                checked={accountMonth.indexOf(num) > -1}
              />
            )
          }
          label={`${num}月`}
          className={`${styles.accountMonthItem}`}
        />,
      );
    }

    // チェックボックスの表示・非表示を設定
    let dispLatestFlg = false;

    if (targetingDispItems) {
      targetingDispItems.search_option_list.forEach((label) => {
        if (label.item_name === TARGET_SEARCH_DISP_ITEM.SETTLEMENT) {
          dispLatestFlg = true;
        }
      });
    }

    return (
      <Box className={`${styles.parts}`}>
        <Paper elevation={0} className={`${styles.sectionBox}`}>
          <Box className={`${styles.alignItemsCenter} ${styles.displayFlex} ${styles.marginBottomTitle}`}>
            <Box className={`${styles.sectionTitleIcon} ${styles.marginRightHalf}`} />
            <Typography variant="h6" component="div" className={`${styles.sectionTitle}`}>
              { dispLatestFlg ? '決算情報' : '当期決算情報'}
            </Typography>
            {dispLatestFlg && (
              <FormControlLabel
                control={(
                  <CustomCheckbox
                    onChange={() => this.checkLatestFlg()}
                    checked={latestFlg === LATEST_FLG.LATEST_ON}
                  />
                )}
                label="最新期のみを検索"
                className={`${styles.marginLeft5}`}
              />
            )}
          </Box>
          <Box className={`${styles.marginBottom2}`}>
            <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>売上高</Typography>
            <Box className={`${styles.displayFlex} ${styles.alignItemsFlexEnd}`}>
              <TextField
                variant="outlined"
                margin="normal"
                value={dispSalesFrom || ''}
                onChange={(ev) => setDispSalesFromAct(ev.target.value)}
                onBlur={this.onBlurSales}
                error={checkErrFlg.checkSalesFrom}
                InputProps={{ classes: { input: styles.inputSizing } }}
                placeholder="0000"
              />
              <Typography variant="body2" className={`${styles.marginLeftHalf} ${styles.marginBottomHalf}`}>千円</Typography>
              <Box className={`${styles.marginRight1} ${styles.marginLeft1} ${styles.marginBottom15}`}>
                <Typography variant="body2">～</Typography>
              </Box>
              <TextField
                variant="outlined"
                margin="normal"
                value={dispSalesTo || ''}
                onChange={(ev) => setDispSalesToAct(ev.target.value)}
                onBlur={this.onBlurSales}
                error={checkErrFlg.checkSalesTo}
                InputProps={{ classes: { input: styles.inputSizing } }}
                placeholder="0000"
              />
              <Typography variant="body2" className={`${styles.marginLeftHalf} ${styles.marginBottomHalf}`}>千円</Typography>
              <Box className={`${styles.errorMsgAreaMargin}`}>
                <Typography variant="body2" className={`${styles.errorMsg}`} component="span">{errMsgSales}</Typography>
              </Box>
            </Box>
          </Box>
          <Box className={`${styles.marginBottom2}`}>
            <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>売上伸長率</Typography>
            <Box className={`${styles.displayFlex} ${styles.alignItemsFlexEnd}`}>
              <TextField
                variant="outlined"
                margin="normal"
                value={dispSalesRateFrom || ''}
                onChange={(ev) => setDispSalesRateFromAct(ev.target.value)}
                onBlur={this.onBlurRate}
                error={checkErrFlg.checkRateFrom}
                InputProps={{ classes: { input: styles.inputSizing } }}
                placeholder="00"
              />
              <Typography variant="body2" className={`${styles.marginLeftHalf} ${styles.marginBottomHalf}`}>％　</Typography>
              <Box className={`${styles.marginRight1} ${styles.marginLeft1} ${styles.marginBottom15}`}>
                <Typography variant="body2">～</Typography>
              </Box>
              <TextField
                variant="outlined"
                margin="normal"
                value={dispSalesRateTo || ''}
                onChange={(ev) => setDispSalesRateToAct(ev.target.value)}
                onBlur={this.onBlurRate}
                error={checkErrFlg.checkRateTo}
                InputProps={{ classes: { input: styles.inputSizing } }}
                placeholder="00"
              />
              <Typography variant="body2" className={`${styles.marginLeftHalf} ${styles.marginBottomHalf}`}>％　</Typography>
              <Box className={`${styles.errorMsgAreaMargin}`}>
                <Typography variant="body2" className={`${styles.errorMsg}`} component="span">{errMsgRate}</Typography>
              </Box>
            </Box>
          </Box>
          <Box className={`${styles.marginBottom2}`}>
            <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>利益金</Typography>
            <Box className={`${styles.displayFlex} ${styles.alignItemsFlexEnd}`}>
              <TextField
                variant="outlined"
                margin="normal"
                value={dispBenefitFrom || ''}
                onChange={(ev) => setDispBenefitFromAct(ev.target.value)}
                onBlur={this.onBlurBenefit}
                error={checkErrFlg.checkBenefitFrom}
                InputProps={{ classes: { input: styles.inputSizing } }}
                placeholder="0000"
              />
              <Typography variant="body2" className={`${styles.marginLeftHalf} ${styles.marginBottomHalf}`}>千円</Typography>
              <Box className={`${styles.marginRight1} ${styles.marginLeft1} ${styles.marginBottom15}`}>
                <Typography variant="body2">～</Typography>
              </Box>
              <TextField
                variant="outlined"
                margin="normal"
                value={dispBenefitTo || ''}
                onChange={(ev) => setDispBenefitToAct(ev.target.value)}
                onBlur={this.onBlurBenefit}
                error={checkErrFlg.checkBenefitTo}
                InputProps={{ classes: { input: styles.inputSizing } }}
                placeholder="0000"
              />
              <Typography variant="body2" className={`${styles.marginLeftHalf} ${styles.marginBottomHalf}`}>千円</Typography>
              <Box className={`${styles.errorMsgAreaMargin}`}>
                <Typography variant="body2" className={`${styles.errorMsg}`} component="span">{errMsgBenefit}</Typography>
              </Box>
            </Box>
          </Box>
          <Box className={`${styles.marginBottom2}`}>
            <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>利益伸長率</Typography>
            <Box className={`${styles.displayFlex} ${styles.alignItemsFlexEnd}`}>
              <TextField
                variant="outlined"
                margin="normal"
                value={dispBenefitRateFrom || ''}
                onChange={(ev) => setDispBenefitRateFromAct(ev.target.value)}
                onBlur={this.onBlurBenefitRate}
                error={checkErrFlg.checkBenefitRateFrom}
                InputProps={{ classes: { input: styles.inputSizing } }}
                placeholder="00"
              />
              <Typography variant="body2" className={`${styles.marginLeftHalf} ${styles.marginBottomHalf}`}>％　</Typography>
              <Box className={`${styles.marginRight1} ${styles.marginLeft1} ${styles.marginBottom15}`}>
                <Typography variant="body2">～</Typography>
              </Box>
              <TextField
                variant="outlined"
                margin="normal"
                value={dispBenefitRateTo || ''}
                onChange={(ev) => setDispBenefitRateToAct(ev.target.value)}
                onBlur={this.onBlurBenefitRate}
                error={checkErrFlg.checkBenefitRateTo}
                InputProps={{ classes: { input: styles.inputSizing } }}
                placeholder="00"
              />
              <Typography variant="body2" className={`${styles.marginLeftHalf} ${styles.marginBottomHalf}`}>％　</Typography>
              <Box className={`${styles.errorMsgAreaMargin}`}>
                <Typography variant="body2" className={`${styles.errorMsg}`} component="span">{errMsgBenefitRate}</Typography>
              </Box>
            </Box>
          </Box>
          <Box>
            <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>決算月</Typography>
            <Box className={`${styles.marginLeftHalf}`}>
              {monthlist}
            </Box>
            <Box className={`${styles.marginLeftHalf}`}>
              {monthlist2}
            </Box>
          </Box>
        </Paper>
      </Box>
    );
  }
}

export default connect(
  (state) => ({
    accountMonth: state.target.accountMonth,
    salesFrom: state.target.salesFrom,
    salesTo: state.target.salesTo,
    salesRateFrom: state.target.salesRateFrom,
    salesRateTo: state.target.salesRateTo,
    benefitFrom: state.target.benefitFrom,
    benefitTo: state.target.benefitTo,
    benefitRateFrom: state.target.benefitRateFrom,
    benefitRateTo: state.target.benefitRateTo,
    dispSalesFrom: state.target.dispSalesFrom,
    dispSalesTo: state.target.dispSalesTo,
    dispSalesRateFrom: state.target.dispSalesRateFrom,
    dispSalesRateTo: state.target.dispSalesRateTo,
    dispBenefitFrom: state.target.dispBenefitFrom,
    dispBenefitTo: state.target.dispBenefitTo,
    dispBenefitRateFrom: state.target.dispBenefitRateFrom,
    dispBenefitRateTo: state.target.dispBenefitRateTo,
    errMsgSales: state.target.errMsgSales,
    errMsgRate: state.target.errMsgRate,
    errMsgBenefit: state.target.errMsgBenefit,
    errMsgBenefitRate: state.target.errMsgBenefitRate,
    checkErrFlg: state.target.checkErrFlg,
    latestFlg: state.target.latestFlg,
    targetingDispItems: state.target.targetingDispItems,
  }),
  (dispatch) => ({
    setAccountMonthAct: (obj) => dispatch(setAccountMonth(obj)),
    setSalesFromAct: (str) => dispatch(setSalesFrom(str)),
    setSalesToAct: (str) => dispatch(setSalesTo(str)),
    setSalesRateFromAct: (str) => dispatch(setSalesRateFrom(str)),
    setSalesRateToAct: (str) => dispatch(setSalesRateTo(str)),
    setBenefitFromAct: (str) => dispatch(setBenefitFrom(str)),
    setBenefitToAct: (str) => dispatch(setBenefitTo(str)),
    setBenefitRateFromAct: (str) => dispatch(setBenefitRateFrom(str)),
    setBenefitRateToAct: (str) => dispatch(setBenefitRateTo(str)),
    setDispSalesFromAct: (str) => dispatch(setDispSalesFrom(str)),
    setDispSalesToAct: (str) => dispatch(setDispSalesTo(str)),
    setDispSalesRateFromAct: (str) => dispatch(setDispSalesRateFrom(str)),
    setDispSalesRateToAct: (str) => dispatch(setDispSalesRateTo(str)),
    setDispBenefitFromAct: (str) => dispatch(setDispBenefitFrom(str)),
    setDispBenefitToAct: (str) => dispatch(setDispBenefitTo(str)),
    setDispBenefitRateFromAct: (str) => dispatch(setDispBenefitRateFrom(str)),
    setDispBenefitRateToAct: (str) => dispatch(setDispBenefitRateTo(str)),
    setErrMsgSalesAct: (sr) => dispatch(setErrMsgSales(sr)),
    setErrMsgRateAct: (sr) => dispatch(setErrMsgRate(sr)),
    setErrMsgBenefitAct: (sr) => dispatch(setErrMsgBenefit(sr)),
    setErrMsgBenefitRateAct: (sr) => dispatch(setErrMsgBenefitRate(sr)),
    setCheckSalesFromAct: (bool) => dispatch(setCheckSalesFrom(bool)),
    setCheckSalesToAct: (bool) => dispatch(setCheckSalesTo(bool)),
    setCheckRateFromAct: (bool) => dispatch(setCheckRateFrom(bool)),
    setCheckRateToAct: (bool) => dispatch(setCheckRateTo(bool)),
    setCheckBenefitFromAct: (bool) => dispatch(setCheckBenefitFrom(bool)),
    setCheckBenefitToAct: (bool) => dispatch(setCheckBenefitTo(bool)),
    setCheckBenefitRateFromAct: (bool) => dispatch(setCheckBenefitRateFrom(bool)),
    setCheckBenefitRateToAct: (bool) => dispatch(setCheckBenefitRateTo(bool)),
    setLatestFlgAct: (bool) => dispatch(setLatestFlg(bool)),
  }),
)(SettlementInfomation);
